export type PlatformRole = "admin" | "coach" | "ranking_admin";

export interface RoleNavigationItem {
  labelKey: string;
  path: string;
}

const admin: RoleNavigationItem[] = [
  { labelKey: "nav.admin.dashboard", path: "/admin" },
  { labelKey: "nav.admin.athletes", path: "/admin/athletes" },
  { labelKey: "nav.admin.clubs", path: "/admin/clubs" },
  { labelKey: "nav.admin.coaches", path: "/admin/coaches" },
  { labelKey: "nav.admin.competitions", path: "/admin/competitions" },
  { labelKey: "nav.admin.registrations", path: "/admin/registrations" },
  { labelKey: "nav.admin.draws", path: "/admin/draw-lab" },
  { labelKey: "nav.admin.rankings", path: "/admin/rankings" },
  { labelKey: "nav.admin.affiliations", path: "/admin/affiliations" },
  { labelKey: "nav.admin.recentRegistrations", path: "/admin/recent-registrations" },
  { labelKey: "nav.admin.audit", path: "/admin/audit" },
  { labelKey: "nav.admin.credits", path: "/admin/credits" },
];

const rankingAdmin: RoleNavigationItem[] = [
  { labelKey: "nav.admin.dashboard", path: "/admin" },
  { labelKey: "nav.admin.athletes", path: "/admin/athletes" },
  { labelKey: "nav.admin.clubs", path: "/admin/clubs" },
  { labelKey: "nav.admin.competitions", path: "/admin/competitions" },
  { labelKey: "nav.admin.draws", path: "/admin/draw-lab" },
  { labelKey: "nav.admin.rankings", path: "/admin/rankings" },
];

const coach: RoleNavigationItem[] = [
  { labelKey: "nav.home", path: "/dashboard" },
  { labelKey: "nav.myClub", path: "/my-club" },
  { labelKey: "nav.history", path: "/history" },
];

export function roleNavigation(role: PlatformRole): RoleNavigationItem[] {
  return role === "admin" ? admin : role === "ranking_admin" ? rankingAdmin : coach;
}
